import { motion } from 'framer-motion';
import { ArrowRight, ShieldCheck, Radar } from 'lucide-react';

const WorkshopHero = () => {
  return (
    <section className="relative overflow-hidden bg-white" data-testid="workshop-hero">
      {/* Decorative background elements */}
      <div className="pointer-events-none absolute -top-24 -left-24 w-96 h-96 rounded-full bg-purple-500/10 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-32 -right-16 w-[28rem] h-[28rem] rounded-full bg-blue-500/10 blur-3xl" />
      
      {/* Floating icons */}
      <div className="pointer-events-none absolute top-20 left-[8%] hidden lg:block text-purple-500/20">
        <ShieldCheck className="w-20 h-20" strokeWidth={1.25} />
      </div>
      <div className="pointer-events-none absolute bottom-16 right-[7%] hidden lg:block text-red-500/20">
        <Radar className="w-24 h-24" strokeWidth={1} />
      </div>

      <div className="relative max-w-5xl mx-auto px-6 pt-20 pb-16 text-center">
        {/* Headline */}
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          className="font-display text-slate-800 text-4xl sm:text-5xl lg:text-6xl leading-[1.1]"
        >
          <span className="block">Your Account Health</span>
          <span className="block">Dashboard is</span>
          <span className="block">
            <span className="relative inline-block italic text-purple-600 px-1">
              Already Behind.
              <span className="absolute -left-1 -right-1 bottom-1 h-[6px] -rotate-1 rounded-full bg-red-500/70 -z-10" />
            </span>
          </span>
        </motion.h1>

        {/* Subheadline */}
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
          className="text-slate-500 text-lg md:text-xl leading-relaxed mt-6 max-w-2xl mx-auto"
        >
          Learn why <span className="font-semibold text-slate-700">Account Health is a lagging indicator</span> — 
          and how to see what Amazon sees before they act on your account.
        </motion.p>

        {/* CTA Button */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
          className="mt-10"
        >
          <a
            href="https://amazonworkshop.section3.ai/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 px-8 py-4 text-lg font-semibold text-white bg-purple-600 hover:bg-purple-700 rounded-full transition-all hover:scale-105 shadow-lg shadow-purple-500/30"
            data-testid="workshop-cta"
          >
            Register for Free Workshop
            <ArrowRight className="w-5 h-5" />
          </a>
        </motion.div>

        {/* Trust indicators */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
          className="mt-8 flex flex-wrap items-center justify-center gap-6 text-sm text-slate-500"
        >
          <span>60 minutes, live</span>
          <span className="w-1 h-1 rounded-full bg-slate-300" />
          <span>Free to attend</span>
          <span className="w-1 h-1 rounded-full bg-slate-300" />
          <span>Limited seats</span>
        </motion.div>

        {/* Amazon Partner Badge */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6 }}
          className="mt-10"
        >
          <a 
            href="https://sellercentral.amazon.ca/selling-partner-appstore/dp/amzn1.sp.solution.a216e31d-d6da-475c-80c3-474556a10e53"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block hover:opacity-80 transition-opacity"
          >
            <img 
              src="/amazon-partner-badge.png" 
              alt="Amazon Selling Partner Appstore - Software Partner" 
              className="h-14 w-auto mx-auto"
            />
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default WorkshopHero;
